import { clampSlugForKey, shortItemId } from './_uilm-key-internals';

/**
 * Build a UILM key for a screen's title or description.
 *
 * The slug head is normalized by `clampSlugForKey` so very long slugs
 * don't overflow the 100-char UILM limit when combined with the fixed
 * `_SCR_S{8HEX}_TITLE` suffix.
 *
 *   uilmKeyForScreen('nda', 'a3f2b1c8-...', 'title')
 *   → 'NDA_SCR_SA3F2B1C8_TITLE'
 */
export type ScreenKeyType = 'title' | 'desc';

export function uilmKeyForScreen(
  templateSlug: string,
  screenItemId: string,
  type: ScreenKeyType,
): string {
  return [
    clampSlugForKey(templateSlug),
    'SCR',
    shortItemId(screenItemId, 'S'),
    type.toUpperCase(),
  ].join('_');
}
